// @ts-nocheck ce666ed8
import loginButtonGfppData from './loginButtonGfppData';
import backToTopButtonGfppData from './backToTopButtonGfppData';
import clipArtGfppData from './clipArtGfppData';

export default {
  LoginButton: loginButtonGfppData,
  BackToTopButton: backToTopButtonGfppData,
  ClipArt: clipArtGfppData,
};
